import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { QuickAction } from './quickActionPresentation';
import { ActionTypeIcon } from './ActionTypeIcon';
import './QuickActionRow.css';

export function QuickActionRow({ choices, hasMore, loading, onChoose, onMore }: {
  choices: QuickAction[]; hasMore: boolean; loading: boolean;
  onChoose: (choice: QuickAction) => void; onMore: () => void;
}) {
  const row = useRef<HTMLDivElement>(null);
  const [blocked, setBlocked] = useState(false);
  const isBlocked = useCallback(() => {
    const dialogs = Array.from(document.querySelectorAll<HTMLElement>('[aria-modal="true"]'))
      .filter(dialog => !dialog.closest('[aria-hidden="true"], [inert], .game-dialog-closing'));
    const top = dialogs[dialogs.length - 1];
    return !!top && !top.contains(row.current);
  }, []);
  useLayoutEffect(() => {
    const update = () => setBlocked(isBlocked());
    update();
    const observer = new MutationObserver(update);
    observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-modal', 'aria-hidden', 'inert'] });
    return () => observer.disconnect();
  }, [isBlocked]);
  if (!choices.length) return null;
  return <div ref={row} className="game-quick-actions" role="group" aria-label="Quick actions" data-blocked={blocked || undefined}>
    {choices.map(choice => <button type="button" key={choice.action.id}
      className={`game-quick-action${choice.kind ? ` fight-action-${choice.kind}` : ''}`}
      aria-label={choice.label} title={choice.action.description || choice.label}
      aria-haspopup={choice.chooser ? 'dialog' : undefined}
      disabled={loading || !!choice.action.disabled} aria-disabled={blocked || undefined} tabIndex={blocked ? -1 : undefined}
      onClick={() => { if (!loading && !choice.action.disabled && !isBlocked()) onChoose(choice); }}>
      <ActionTypeIcon action={choice.action} kind={choice.kind} /><span className="game-quick-action-label">{choice.label}</span>
    </button>)}
    {hasMore && <button type="button" className="game-quick-actions-more" aria-label="More actions" title="More actions"
      aria-haspopup="dialog" aria-disabled={blocked || undefined} tabIndex={blocked ? -1 : undefined}
      onClick={() => { if (!isBlocked()) onMore(); }}><span aria-hidden="true">…</span></button>}
  </div>;
}
